var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 36C0 16.1178 16.1178 0 36 0C55.8823 0 72 16.1178 72 36C72 55.8823 55.8823 72 36 72C16.1178 72 0 55.8823 0 36Z",
    fill: "#F4F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34H26C25.7348 34 25.4804 33.8946 25.2929 33.7071C25.1054 33.5196 25 33.2652 25 33V26C25 25.7348 25.1054 25.4804 25.2929 25.2929C25.4804 25.1054 25.7348 25 26 25H33C33.2652 25 33.5196 25.1054 33.7071 25.2929C33.8946 25.4804 34 25.7348 34 26V33C34 33.2652 33.8946 33.5196 33.7071 33.7071C33.5196 33.8946 33.2652 34 33 34Z",
    fill: "#17C9BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 47H26C25.7348 47 25.4804 46.8946 25.2929 46.7071C25.1054 46.5196 25 46.2652 25 46V39C25 38.7348 25.1054 38.4804 25.2929 38.2929C25.4804 38.1054 25.7348 38 26 38H33C33.2652 38 33.5196 38.1054 33.7071 38.2929C33.8946 38.4804 34 38.7348 34 39V46C34 46.2652 33.8946 46.5196 33.7071 46.7071C33.5196 46.8946 33.2652 47 33 47Z",
    fill: "#567DCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 26H47V28H37V26Z",
    fill: "#17C9BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47 39H37V41H47V39Z",
    fill: "#567DCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47 44H37V46H47V44Z",
    fill: "#C4C4C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47 31H37V33H47V31Z",
    fill: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.fd317cd0b8bf1fc9b75bde30bf865e73.svg";
export { ForwardRef as ReactComponent };